module.exports = __webpack_public_path__ + "static/media/laptop-medical.9bddd640.svg";